﻿import '@fancyapps/fancybox';
import '@fancyapps/fancybox/dist/jquery.fancybox.css';

export async function DiagramFancybox() {
    //Fancybox
    $(".fancybox").fancybox();

    $('.fancybox-media').fancybox({
        openEffect: 'none',
        closeEffect: 'none'
    });

    $('.fancybox-modal').fancybox({
        openEffect: 'none',
        closeEffect: 'none',
        modal: true,
        title: null
    });
};